/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  useState, useEffect, useRef, useCallback,
} from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { Creators as UiCreators, growlTypes } from 'store/ducks/ui';
import closeIcon from 'assets/img/icons/close.svg';
import userAdd from 'assets/img/icons/userAdd.svg';

import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as RespCreators } from 'store/ducks/companyResponsibility';
import {
  apiGetTaskNfs,
  apiGetTaskPaymentTicket,
  setTagNewTask,
  setTagNewQuote,
} from 'services/api/task';
import { ButtonCopyCheckoutLink } from 'config/shared';
import { Spinner } from 'triider-components';
import LinkIdTask from 'components/LinkIdTask';
import SEGMENTS from '../../../helpers/segment';
import HandleClickOutside from '../../../helpers/handleClickOutside';
import DownloadReportModal from '../../TaskDetails/DownloadReportModal';

import LinkUserTask from '../LinkUserTask';
import CardUser from '../CardUser';
import ResponsibleOrder from './ResponsibleOrderModal';
import TaskLabel from './TaskLabel';

import {
  Wrapper,
  ContentDetailsTask,
  BadgeLabel,
  DateOfTask,
  ManageTask,
  AddressTask,
  ServiceTitleCard,
  StatusTask,
  ContentRow,
  ContentPersonTask,
  ContentButtonsHover,
  RequestTask,
  ContentAddressTask,
  ContentLengthTasks,
  CodeImmobile,
  ContentOnHover,
  ChooseResponsibility,
  ContentServiceResponsibility,
  TitleResponsibility,
  ResumeButton as DownloadBtn,
  DividerPersonTask,
  TooltipClient,
  LabelText,
} from './styles';


const GetLastContentRow = ({ hasQuotesLenght }) => (
  <>
    <h1>{hasQuotesLenght}</h1>
    <p>{hasQuotesLenght === 1 ? 'orçamento' : 'orçamentos'}</p>
  </>
);

const Row = ({
  task,
  statusActived,
  goToDetails,
  company,
  userId,
  isAdmin,
  roles,
  taskDetail,
  loadingVisibleResume,
  loadingVisibleModal,
  loadingTaskVisit,
  loadingTaskIsNeedVisit,
  loadingSetOperator,
  _setResponsibilities,
  _getTaskDetail,
  _setTaskVisited,
  _setTaskOperator,
  _editTaskVisit,
  _growl,
  _setUserSuccess,
  _push,
}) => {
  const [isModalResp, setIsModalResp] = useState(false);
  const [isModalDownloadResume, setIsModalDownloadResume] = useState(false);
  const [responsibilitySelected, setResponsibilitySelected] = useState({});
  const [hasQuotesLenght, setQuotes] = useState(0);
  const [isOpenLinkClientUser, setIsOpenLinkClientUser] = useState(false);
  const [isOpenTooltipUser, setIsOpenTooltipUser] = useState(false);
  const [isOpenLabelModal, setIsOpenLabelModal] = useState(false);
  const imobSegment = company.segment_id === null || company.segment_id === SEGMENTS.IMOBILIARIA;
  const linkRef = useRef(null);
  const contentDetailRef = useRef(null);
  const rowLabelsRef = useRef(null);
  const contentLabelsRef = useRef(null);
  const contentExternalCode = useRef(null);

  useEffect(() => {
    let counter = 0;
    if (task.quotes.length > 0) {
      task.quotes.forEach((element) => {
        if (element.price) {
          counter += 1;
        }
      });
    }
    setQuotes(counter);
  }, [task]);
  const openModal = (role) => {
    setResponsibilitySelected(role);
    setIsModalResp(true);
  };
  const closeModal = () => {
    setIsModalResp(false);
    setResponsibilitySelected({});
  };

  const setIsOpenLink = (openLink) => {
    setIsOpenLinkClientUser(openLink);
    setIsOpenTooltipUser(false);
  };

  const capitalize = word => word[0] && word[0].toUpperCase() + word.substr(1).toLowerCase();

  const getFirstAndLastName = (name) => {
    const names = name && name.trim().split(' ');
    if (!names || names.length === 0) {
      return name;
    }

    const modifiedName = `${capitalize(names[0])} ${capitalize(names[names.length - 1])}`;
    return modifiedName.length > 14
      ? `${modifiedName.substring(14, 0)}...`
      : modifiedName;
  };

  const getStatusTask = () => {
    if (statusActived === 4) {
      return task.status === 'canceled' ? 'Cancelado' : 'Pago';
    }
    if (!task.task_read) {
      return 'Novo pedido';
    }

    if (!task.quote_read && hasQuotesLenght) {
      return 'Novo orçamento';
    }

    return false;
  };

  const openModalResume = async () => {
    await _getTaskDetail(task.id);
    setIsModalDownloadResume(true);
  };

  const handleDownloadInvoice = async () => {
    const { nfs } = await apiGetTaskNfs(task.id);
    if (nfs.length > 0) {
      nfs.forEach((nf) => {
        window.open(nf.file_url, '_blank');
      });
    } else {
      window.alert('Nenhuma Nota Fiscal encontrada!');
    }
  };

  const handleDownloadPaymentTicket = async () => {
    const { list } = await apiGetTaskPaymentTicket(task.id);
    if (list.length > 0) {
      list.forEach((bo) => {
        window.open(bo.invoice_url, '_blank');
      });
    } else {
      window.alert('Nenhum Boleto encontrado!');
    }
  };

  const getLabels = useCallback(() => task.labels.map((label, i) => {
    if (i < 2) {
      return (
        // Trocar pelo componente padrão BadgeLabel
        <BadgeLabel key={label.id} color={label.color} onClick={() => setIsOpenLabelModal(true)}>
          <LabelText color={label.color}>{label.name}</LabelText>
        </BadgeLabel>
      );
    }
    return '';
  }), [task.labels]);

  const openDetails = async (event) => {
    if (!task.task_read) {
      await setTagNewTask(company.id, task.id);
    }

    if (!task.quote_read && hasQuotesLenght) {
      await setTagNewQuote(company.id, task.id);
    }
    if ((!linkRef.current
        || (linkRef.current && !linkRef.current.contains(event.target)))
        && (!contentLabelsRef.current
          || (contentLabelsRef.current && !contentLabelsRef.current.contains(event.target)))
          && (!contentExternalCode.current
            || (contentExternalCode.current && !contentExternalCode.current.contains(event.target)))
    ) {
      goToDetails();
    }
  };

  const getContentOperatorTask = () => {
    if (loadingSetOperator) {
      return <Spinner size="small" />;
    }

    if (!task.operator_id) {
      return (
        <ManageTask
          hover
          pointer
          adminTask
          onClick={() => _setTaskOperator({ task_id: task.id, operator_id: userId })}
        >
          Administrar este pedido
        </ManageTask>
      );
    }

    if (task.operator_id === userId) {
      return (
        <>
          <ManageTask isManaging iAmManaging> Administrado por você </ManageTask>
          <img
            style={{
              marginLeft: '10px',
              cursor: 'pointer',
            }}
            onClick={() => _setTaskOperator({ task_id: task.id })}
            src={closeIcon}
            width="10px"
            height="10px"
            alt="Desvincular usuário ao pedido"
          />
        </>
      );
    }

    return (
      <>
        <span style={{ width: '100px !important' }}>Administrado por:</span>
        <ManageTask isManaging>
          {getFirstAndLastName(task.operator_name)}
        </ManageTask>
      </>
    );
  };

  const getDateOfTask = () => {
    let taskStatus = '';
    let dateValue = '';
    switch (task.status) {
      case 'hired':
        taskStatus = 'Contratado em';
        dateValue = task.selected_date;
        break;
      case 'charged':
        taskStatus = 'Serviço realizado em';
        dateValue = task.schedule_date;
        break;
      case 'canceled':
        taskStatus = 'Cancelado em';
        dateValue = task.updated_at;
        break;
      case 'paid':
        taskStatus = 'Pago em';
        dateValue = task.paid_date;
        break;
      case 'open':
        taskStatus = 'Pedido em';
        dateValue = task.created;
        break;
      default:
        return '';
    }

    return (
      task.status !== 'canceled' && (
        <DateOfTask>
          {taskStatus}
          &nbsp;
          {dateValue && moment(dateValue).format('DD/MM/YYYY')}
        </DateOfTask>
      )
    );
  };

  return (
    <Wrapper
      wrapperHover={task.status !== 'canceled' && imobSegment}
      isCanceled={task.status === 'canceled'}
    >
      <ContentRow>
        <ContentDetailsTask ref={contentDetailRef} isAdmin={isAdmin} onClick={openDetails}>
          <div
            ref={rowLabelsRef}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {getStatusTask()
            && (
            <StatusTask
              typeStatus={getStatusTask()}
            >
              {getStatusTask()}
            </StatusTask>
            )
            }
            {task.labels && task.labels.length > 0 && (
            <span
              ref={contentLabelsRef}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: 'auto',
              }}
            >
              {getLabels()}
              {
                task.labels.length > 2
                && (
                // Trocar pelo componente padrão BadgeLabel
                <BadgeLabel color="#30626B" onClick={() => setIsOpenLabelModal(true)}>
                  <LabelText color="#30626B">
                    +
                    {task.labels.length - 2}
                  </LabelText>
                </BadgeLabel>
                )
              }
            </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ServiceTitleCard>{task.service_name}</ServiceTitleCard>

            <LinkIdTask linkToRef={linkRef} idTask={task.id} />

          </div>
          {getDateOfTask()}
        </ContentDetailsTask>
        <ContentPersonTask>
          <HandleClickOutside
            onClickOutside={() => imobSegment && setIsOpenTooltipUser(false)}
          >
            <DividerPersonTask noPointer bottomDashed>
              <span>Solicitado por:</span>
              <RequestTask
                noPointer={imobSegment}
                onClick={() => imobSegment && setIsOpenTooltipUser(!isOpenTooltipUser)}
                source={imobSegment && task.source}
              >
                <p>{getFirstAndLastName(task.user_name)}</p>
              </RequestTask>
            </DividerPersonTask>
            <DividerPersonTask noPointer isEnd>
              {getContentOperatorTask()}
            </DividerPersonTask>
            <TooltipClient source={task.source} isOpen={isOpenTooltipUser}>
              {task.source === 'company'
                ? (
                  <>
                    <span />
                    <div>
                      <img
                        src={userAdd}
                        onClick={() => setIsOpenLink(!isOpenLinkClientUser)}
                        alt="Ícone de adição de usuário"
                      />
                      <p>Vincular usuário à este pedido</p>
                    </div>
                  </>
                )
                : (
                  <>
                    <span />
                    <CardUser user={{
                      name: task.user_name,
                      picture: task.profile_picture,
                      email: task.user_email,
                      phone: task.user_phone,
                      qtd_last_tasks: task.qtd_last_user_tasks,
                    }}
                    />
                  </>
                )
              }
            </TooltipClient>
          </HandleClickOutside>
        </ContentPersonTask>
        <ContentAddressTask onClick={openDetails}>
          <AddressTask>{task.address}</AddressTask>
          {imobSegment && task.address_external_code
          && (
            <div ref={contentExternalCode} style={{ display: 'flex', alignItems: 'center' }}>
              <CodeImmobile>
                Código do imóvel:
                {' '}
                {task.address_external_code}
              </CodeImmobile>
            </div>
          )
          }
        </ContentAddressTask>
        <ContentLengthTasks>
          <GetLastContentRow
            hasQuotesLenght={hasQuotesLenght}
          />
        </ContentLengthTasks>
      </ContentRow>
      <ContentOnHover>
        {imobSegment && roles.length > 0 && (
        <ContentServiceResponsibility>
          <TitleResponsibility>
            {statusActived === 1 ? 'Definir responsável: ' : 'Responsável: '}
          </TitleResponsibility>
          {roles.map((role) => {
            if (
              (statusActived === 1 && role.show_select_responsibility)
                  || (statusActived !== 1
                    && role.responsibility_bucket_id === task.responsibility_bucket_id)
            ) {
              return (
                <ChooseResponsibility
                  isDisabled={role.responsibility_bucket_id === task.responsibility_bucket_id}
                  type="button"
                  key={role.id}
                  onClick={
                        role.responsibility_bucket_id !== task.responsibility_bucket_id
                          ? () => openModal(role)
                          : null
                      }
                  actived={role.responsibility_bucket_id === task.responsibility_bucket_id}
                >
                  <span>
                    {role.company_responsibility && capitalize(role.company_responsibility)}
                  </span>
                </ChooseResponsibility>
              );
            }
            return '';
          })}
        </ContentServiceResponsibility>
        )}
        <ButtonCopyCheckoutLink task={task} style={{ marginRight: 10 }} />
        {imobSegment && statusActived === 1 && ( // aguardando orçamentos
        <ContentButtonsHover>
          <DownloadBtn
            paddingIcon="12px"
            paddingRight="15px"
            type="button"
            onClick={() => openModalResume()}
          >
            Baixar resumo
          </DownloadBtn>
        </ContentButtonsHover>
        )}
        {(statusActived === 3 || (statusActived === 4 && task.status === 'paid')) && ( // pagamento pendente || Finalizados
        <ContentButtonsHover>
          <DownloadBtn
            paddingIcon="5px"
            paddingRight="8px"
            textAlign="right"
            type="button"
            onClick={() => handleDownloadInvoice()}
          >
            Baixar Nota Fiscal
          </DownloadBtn>
        </ContentButtonsHover>
        )}
        {statusActived === 3 && ( // pagamento pendente
        <ContentButtonsHover>
          <DownloadBtn
            paddingIcon="8px"
            paddingRight="23px"
            type="button"
            onClick={() => handleDownloadPaymentTicket()}
          >
            Baixar boleto
          </DownloadBtn>
        </ContentButtonsHover>
        )}
      </ContentOnHover>
      {isOpenLinkClientUser
        && (
        <LinkUserTask
          _setUserSuccess={_setUserSuccess}
          _growlTypes={growlTypes}
          _growl={_growl}
          isOpen={isOpenLinkClientUser}
          setIsOpen={setIsOpenLinkClientUser}
          task={task}
        />
        )
      }
      {!loadingVisibleResume && taskDetail && taskDetail.fields && (
        <DownloadReportModal
          isOpen={isModalDownloadResume}
          setModalVisible={setIsModalDownloadResume}
          taskDetail={taskDetail}
          company={company}
        />
      )}

      <ResponsibleOrder
        task={task}
        responsibilitySelected={responsibilitySelected}
        isOpen={isModalResp}
        closeModal={closeModal}
        loadingVisibleModal={loadingVisibleModal}
        _setResponsibilities={_setResponsibilities}
      />
      <TaskLabel
        task={task}
        isOpen={isOpenLabelModal}
        setIsOpen={setIsOpenLabelModal}
        isAdmin={isAdmin}
        _push={_push}
      />
    </Wrapper>
  );
};

const mapStateToProps = state => ({
  statusActived: state.task.statusFilterActived.id,
  roles: state.companyResponsibility.roles,
  company: state.auth.triiderUser.company,
  userId: state.auth.triiderUser.user.id,
  isAdmin: state.auth.triiderUser.user.is_admin,
  taskDetail: state.task.taskDetail,
  loadingVisibleResume: state.ui.loaders.includes('TASK_DETAIL'),
  loadingVisibleModal: state.ui.loaders.includes('COMPANY_RESP'),
  loadingSetOperator: state.ui.loaders.includes('SET_OPERATOR_TASK'),
  loadingTaskVisit: state.ui.loaders.includes('SET_TASK_VISIT'),
  loadingTaskIsNeedVisit: state.ui.loaders.includes('SET_TASK_VISITED_IS_NEED_VISIT'),
});

const mapDispatchToProps = {
  _getTaskDetail: TaskCreators.getTaskDetailRequest,
  _setTaskVisited: TaskCreators.setTaskIsNeededVisitRequest,
  _editTaskVisit: TaskCreators.editTaskVisitRequest,
  _setTaskOperator: TaskCreators.setTaskOperatorRequest,
  _getResponsibilities: RespCreators.getResponsibilitiesRequest,
  _setResponsibilities: RespCreators.setResponsibilitiesRequest,
  _growl: UiCreators.growl,
  _setUserSuccess: TaskCreators.setTaskUserSuccess,
  _push: push,
};

export default connect(mapStateToProps, mapDispatchToProps)(Row);
